import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {irr} from 'node-irr';
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});
export default function DenseTable(props: any) {
    const classes = useStyles();
    let rows = props.state.data.output.vulList;
    let dataArray: any = [0];
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell align="right">Age</TableCell>
                        <TableCell align="right">Year</TableCell>
                        <TableCell align="right">Premium</TableCell>
                        <TableCell align="right">Curr_Cash_Val</TableCell>
                        <TableCell align="right">Current_Surrender_Val</TableCell>
                        <TableCell align="right">Current_Death_Benefit</TableCell>
                        <TableCell align="right">IRR %</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row: any, index: number, arr: any) => {
                        if (index !== 0) {
                            dataArray[index - 1] = -row.Premium;
                            dataArray[index] = row.Curr_Cash_Val - row.Premium;
                        }
                        return (
                            <TableRow key={row.Age}>
                                <TableCell align="right" component="th" scope="row">
                                    {row.Age}
                                </TableCell>
                                <TableCell align="right">{row.Year}</TableCell>
                                <TableCell align="right">{row.Premium}</TableCell>
                                <TableCell align="right">{row.Curr_Cash_Val}</TableCell>
                                <TableCell align="right">{row.Current_Surrender_Val}</TableCell>
                                <TableCell align="right">{row.Current_Death_Benefit}</TableCell>
                                <TableCell align="right">{`${(irr(dataArray) * 100).toPrecision(4)}%`}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
